export default __webpack_public_path__ + "static/media/lupaTransparent.e04040e3.svg";